module.exports = __webpack_public_path__ + "a4412c7f62715bb82b49437b976ebd41.png";


//////////////////
// WEBPACK FOOTER
// ./about/Aubermensuel.png
// module id = 455
// module chunks = 0